import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { DuplicateExpenseUseCase } from './DuplicateExpenseUseCase'

export const duplicateExpenseUseCase = new DuplicateExpenseUseCase({
  expenseRepository,
}).execute
